import io from "socket.io-client";

const GATEWAY_URL = process.env.REACT_APP_WEBSOCKET_URL;

class SocketManager {
  constructor() {
    this.socket = null;
    this.connected = false;
    this.listeners = new Map();
    this.connectCallbacks = new Set();
    this.disconnectCallbacks = new Set();
  }

  connect() {
    if (this.socket) {
      if (this.socket.connected) return;
      if (this.socket.io?.engine?.readyState === "opening") return;
      this.socket.removeAllListeners();
      this.socket.disconnect();
      this.socket = null;
    }

    const token = localStorage.getItem("token");

    try {
      this.socket = io(GATEWAY_URL, {
        transports: ["websocket"],
        auth: { token },
      });

      this.socket.on("connect", () => {
        this.connected = true;
        this.connectCallbacks.forEach((cb) => cb());
      });

      this.socket.on("disconnect", (reason) => {
        this.connected = false;
        if (reason === "io server disconnect") {
          setTimeout(() => this.socket?.connect(), 1000);
        }
        this.disconnectCallbacks.forEach((cb) => cb());
      });

      this.socket.on("connect_error", (error) => {
        console.error("Socket connection error:", error);
        this.connected = false;
        this.disconnectCallbacks.forEach((cb) => cb());
      });
    } catch (error) {
      console.error("Error creating socket:", error);
      this.connected = false;
    }
  }

  disconnect() {
    if (!this.socket) return;

    this.socket.removeAllListeners();
    this.socket.disconnect();
    this.socket = null;
    this.connected = false;
  }

  on(event, callback) {
    if (!this.socket) {
      console.warn("Socket not initialized");
      return () => {};
    }

    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event).add(callback);
    this.socket.on(event, callback);

    return () => this.off(event, callback);
  }

  off(event, callback) {
    this.socket?.off(event, callback);
    if (this.listeners.has(event)) {
      this.listeners.get(event).delete(callback);
      if (this.listeners.get(event).size === 0) {
        this.listeners.delete(event);
      }
    }
  }

  emit(event, data) {
    if (this.socket) {
      return this.socket.emit(event, data);
    }
    return false;
  }

  isConnected() {
    return this.connected;
  }

  onConnect(callback) {
    this.connectCallbacks.add(callback);
    return () => this.connectCallbacks.delete(callback);
  }

  onDisconnect(callback) {
    this.disconnectCallbacks.add(callback);
    return () => this.disconnectCallbacks.delete(callback);
  }
}

const socketManager = new SocketManager();
export default socketManager;
